import * as React from 'react'

import { useCommentForm } from './hooks'
import { submitForm } from './model'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormSelect,
  CFormTextarea,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilLockLocked } from '@coreui/icons'
import { $userRole } from '../../../features/user'
import { useStore } from 'effector-react'
const handleLogin = (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault()
  submitForm({
    // @ts-ignore
    entityType: e.target.entityType.value,
    // @ts-ignore
    entityId: e.target.entityId.value,
    // @ts-ignore
    message: e.target.message.value,
    // @ts-ignore
    department: e.target.department.value,
    // @ts-ignore
    visibility: e.target.visibility.value,
    // @ts-ignore
    type: Number(e.target.type.value),
  })
}

type Props = {
  type: string
  entityId: string | number
}
export const CommentForm = ({ type, entityId }: Props) => {
  const { form } = useCommentForm()
  const { loading, error } = form
  const userRole = useStore($userRole)

  return (
    <CRow className="justify-content-center">
      <CCol>
        <CCardGroup>
          <CCard>
            <CCardBody>
              <CForm
                className="row g-3 needs-validation"
                noValidate
                onSubmit={handleLogin}
              >
                <CFormInput hidden={true} name="entityType" value={type} />
                <CFormInput hidden={true} name="entityId" value={entityId} />
                <CFormInput
                  hidden={true}
                  name="department"
                  value={userRole?.[0]}
                />
                <CInputGroup className="mb-3">
                  <CFormTextarea
                    placeholder="Comment"
                    name="message"
                    required
                  />
                  <CFormFeedback invalid>Field is required</CFormFeedback>
                </CInputGroup>
                <CInputGroup className="mb-4">
                  <CInputGroupText>
                    <CIcon icon={cilLockLocked} />
                  </CInputGroupText>
                  <CFormSelect
                    type="visibility"
                    name="visibility"
                    placeholder="Password"
                    autoComplete="current-password"
                    required
                  >
                    <option value="all">All</option>
                    <option value="support">Support</option>
                    <option value="finance">Finance</option>
                    <option value="dealing">Dealing</option>
                  </CFormSelect>
                </CInputGroup>
                <CInputGroup className="mb-4">
                  <CFormSelect
                    name="type"
                    placeholder="Comment type"
                    autoComplete="current-password"
                    required
                  >
                    <option value="2">Info</option>
                    <option value="1">Warning</option>
                    <option value="0">Alert</option>
                  </CFormSelect>
                </CInputGroup>
                <CRow>
                  <CCol xs={6}>
                    <CButton
                      color="primary"
                      className="px-4"
                      type="submit"
                      disabled={loading}
                    >
                      {loading && (
                        <span className="spinner-border spinner-border-sm"></span>
                      )}
                      Comment
                    </CButton>
                  </CCol>
                </CRow>
                <CRow className="mt-4">
                  <CCol>
                    {error && (
                      <div className="form-group">
                        <div className="alert alert-danger" role="alert">
                          {error?.msg}
                        </div>
                      </div>
                    )}
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  )
}
